// TODO: This "service" should be refactored out into lib/ as individual methods.
import config from 'config';
import sumBy from 'lodash/sumBy';
import sortBy from 'lodash/sortBy';

export function pricesForZone(prices, zone) {
    var zonePrices = prices.filter(function (price) {
        return parseInt(price.zone_no, 10) === zone;
    });

    var rankedPriceTypes = sortBy(zonePrices, function (obj) {
        return parseInt(obj.rank, 10);
    });

    return rankedPriceTypes;
}

export function toCurrency(priceStr, curr) {
    return (curr || config.currency) + parseFloat(priceStr, 10).toFixed(2);
}

// TODO: Extract currency formatting from this method
export function calculateTotal(prices, curr) {
    var total = sumBy(prices, price => parseFloat(price, 10));
    return toCurrency(total, curr || config.currency);
}

export default {
    pricesForZone,
    toCurrency,
    calculateTotal
}



// WEBPACK FOOTER //
// ./src/javascripts/app/services/Pricer.js